<template>
  <div>
    <DoctorDashboardCard>
      <template v-slot:title>
        <h3>
          <v-icon class="primary--text pr-2">error_outline</v-icon>
          Patients en alerte orange
          <v-chip v-if="events.length"
                  class="red">{{events.length}}
          </v-chip>
        </h3>
      </template>
      <template v-slot:text>
        <v-list v-if="events.length"
                two-line>
          <template v-for="(event, index) in events">
            <span :key="event.patient.id">
              <span>
                <span>{{event.patient.first_name}} {{event.patient.last_name}}</span>
              </span>

              <span>
                <v-btn icon
                       ripple
                       @click="dialog.show = true; dialog.event = event">
                  <v-icon color="primary">arrow_forward</v-icon>
                </v-btn>
              </span>

            </span>
            <v-divider v-if="index + 1 < events.length"></v-divider>
          </template>
        </v-list>
        <h2 v-else
            class="text-center pb-5"
            style="color: #757575">Aucun patient en attente.</h2>
      </template>
      <template v-slot:info-text>
        Patients inactifs depuis au moins 10 jours
      </template>
    </DoctorDashboardCard>
    <IriadeSettingsDialog :show="dialog.show"
                          v-if="dialog.event.patient.id">
      <v-card>
        <v-card-title class="headline primary white--text"
                      style="display: flex; justify-content: space-between; position: sticky; top: 0px; z-index: 10;">
          <span>{{dialog.event.patient.first_name}} {{dialog.event.patient.last_name}} - valider la mission</span>
          <span class="pointer"
                @click="closeDialog">X</span>
        </v-card-title>
        <v-card-text>
          <MangoCaption class="mt-5"><b>Contexte</b> : Ce patient ne s'est pas connecté à la plateforme depuis au moins 10 jours
          </MangoCaption>
          <MangoCaption class="mt-5"><b>Objectif</b> : info - patient en ALERTE orange</MangoCaption>
          <MangoCaption class="mt-5"><b>Instructions</b> : Pour réaliser cette mission, vous devez :
            <ol>
              <li>Contacter le patient</li>
              <li>Insérer un commentaire si vous le souhaitez</li>
              <li>VALIDER la mission</li>
            </ol>
          </MangoCaption>
          <MangoCaption style="color: darkorange">
            <v-icon style="color: darkorange">warning</v-icon>Si vous validez cette mission sans la clôturer, elle restera dans vos alertes à traiter.<br/>À l'inverse, si vous la clôturez, elle disparaîtra de votre journal de bord.
          </MangoCaption>
          <router-link :to="{name: 'patients@find', params: {patient_id: dialog.event.patient.id, moduleName: 'suivi'}}"><h3 style="text-align: center">{{dialog.event.patient.first_name}} {{dialog.event.patient.last_name}}</h3></router-link>
          <div style="display: flex; flex-direction: row; justify-content: space-around" class="mt-4 mb-8">
            <div style="display: flex; flex-direction: column;">
              <p>Consulter le rapport du patient</p>
              <router-link :to="{name: 'doctors@report', params: {report_id: dialog.event.report_id}}" target='_blank'
                           class="mx-auto">
                <IriadeButton class="mb-3"
                              style="max-width: 50px; margin: 0 auto">
                  <v-icon>assignment</v-icon>
                </IriadeButton>
              </router-link>
            </div>
          </div>
          <div style="display: flex; justify-content: space-around"
               class="mt-4 mb-8">
            <div style="display: flex; flex-direction: column;">
              <p>Contacter le patient par messagerie</p>
              <router-link
                :to="{name: 'patients@find', params: {patient_id: dialog.event.patient.id, moduleName: 'messagerie'}}"
                target="_blank" class="mx-auto">
                <IriadeButton class="mb-3"
                              style="max-width: 50px; margin: 0 auto">
                  <v-icon>mail</v-icon>
                </IriadeButton>
              </router-link>
            </div>
            <div style="display: flex; flex-direction: column">
              <p>Contacter le patient par téléphone</p>
              <IriadeButton class="mb-3"
                            style="max-width: 50px; margin: 0 auto"
                            :href="`tel:${dialog.event.patient.user.phone_number}`">
                <v-icon>phone</v-icon>
              </IriadeButton>
              <span style="margin: 0 auto">{{spacedPhoneNumber}}</span>
            </div>
          </div>
          <div class="mb-5">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Historique des contacts avec ce patient ({{dialog.event.etat_activite.length}})</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-for="(historique, index_h) in dialog.event.etat_activite">{{historique.doctor.first_name}} {{historique.doctor.last_name}} le {{historique.created_at | moment('L')}} à {{historique.created_at | moment('LT')}}</div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div>
            <v-radio-group v-model="dialog.cloture" label="Souhaitez-vous clôturer cette mission ?">
              <v-radio label="Oui, j'ai contacté ce patient" :value="true"></v-radio>
              <v-radio label="Non, je n'ai pas encore contacté ce patient" :value="false"></v-radio>
            </v-radio-group>
          </div>

          <IriadeTextarea label="Commentaires"
                          :disabled="dialog.cloture !== true"
                          v-model="dialog.comments"></IriadeTextarea>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="dialog.cloture !== true"
                 block
                 class="primary"
                 :loading="dialog.loading"
                 @click="setSeen">Valider la mission
          </v-btn>
        </v-card-actions>
      </v-card>
    </IriadeSettingsDialog>
  </div>
</template>

<script>
import api from 'api'
import DoctorDashboardCard from 'components/Iriade/DoctorDashboardCard'
import {chunk} from 'helpers'

export default {
  components: {DoctorDashboardCard},

  computed: {
    spacedPhoneNumber() {
      return chunk(this.dialog.event.patient.user.phone_number, 2).join(' ')
    }
  },

  data: () => ({
    events: [],
    dialog: {
      show: false,
      loading: false,
      event: {
        alert: {},
        patient: {}
      },
      checkbox: false,
      comments: null,
      contact: null,
      cloture: null,
    }
  }),

  methods: {
    closeDialog() {
      this.dialog.show = false;
      this.dialog.checkbox = false;
      this.dialog.comments = null;
      this.dialog.contact = null;
      this.dialog.cloture = null;
      this.dialog.loading = false;
      this.dialog.event = {
        alert: {},
        patient: {},
      };
    },

    refresh() {
      api.get(`dashboard/modules/find`, {params: {class_name: this.module.class_name}})
        .then(res => {
          this.events = res.data
        })
    },

    setSeen() {
      this.dialog.loading = true;

      if (this.dialog.cloture) {
        api.put(`obecoach/patients/alerts/${this.dialog.event.alert.id}`, {comments: this.dialog.comments})
        .then(_ => {
          this.refresh();
          this.closeDialog();
        });
      }

    }
  },

  mounted() {
    this.refresh()
  },

  props: ['module']
}
</script>
